import { render, staticRenderFns } from "./EvidenceSubmissionNextSteps.vue?vue&type=template&id=4ea6b7a4&scoped=true&"
import script from "./EvidenceSubmissionNextSteps.vue?vue&type=script&lang=js&"
export * from "./EvidenceSubmissionNextSteps.vue?vue&type=script&lang=js&"
import style0 from "./EvidenceSubmissionNextSteps.vue?vue&type=style&index=0&id=4ea6b7a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea6b7a4",
  null
  
)

export default component.exports